"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { useEffect, useState } from "react";
import { Toaster } from "sonner";

// One-time migration: legacy "idea_theme_mode" used to override theme to light/dark.
// We now trust next-themes (which uses localStorage["theme"]) — wipe legacy keys so
// existing visitors fall back to defaultTheme="system".
function LegacyThemeReset() {
  useEffect(() => {
    try {
      const migrationKey = "idea_theme_migrated_v2";
      if (window.localStorage.getItem(migrationKey)) return;
      window.localStorage.removeItem("idea_theme_mode");
      window.localStorage.removeItem("theme");
      window.localStorage.setItem(migrationKey, "1");
    } catch {}
  }, []);
  return null;
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            staleTime: 30_000,
            refetchOnWindowFocus: false
          }
        }
      })
  );

  // enableSystem 必须开：关掉的话 next-themes 根本不认 "system" 这个值，
  // 设置页选「跟随系统」调 setTheme("system") 就是空转
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <LegacyThemeReset />
      <QueryClientProvider client={queryClient}>
        {children}
        <Toaster closeButton position="top-right" />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
